import React from 'react';
import { Menu, MenuItem, Box } from '@material-ui/core';
import { ViewList, ViewModule, MoreVert, FilterList } from '@material-ui/icons';
import { ISortMenuViewTypes, ISortMenuOrderbyTypes, IDotMenu } from '@app/models';
import {
    OrganizationsSelect,
    PasslyDotMenu,
    PasslyButton,
    LaunchpadSortingComponent,
    BullPhishOrganizationsSelect,
    JitOrganizationsSelect
} from '@app/components';
import { useSelector, useDispatch } from 'react-redux';
import { changeViewType, sortingFiltersEnabled } from '@app/store/actions';

export const ListPageBar = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const sortingEnabled: boolean = useSelector((state: any) => state.listPageBar.showMenu);
    const showOrganizationsSelect: boolean = useSelector((state: any) => state.listPageBar.showOrganizationsSelect);
    const showJitOrganizationsSelect: boolean = useSelector((state: any) => state.listPageBar.showJitOrganizationsSelect);
    const showSortingFiltersMenu: boolean = useSelector((state: any) => state.listPageBar.sortingFiltersEnabled);
    const showBullPhishOrganizationsSelect: boolean = useSelector((state: any) => state.listPageBar.showBullPhishOrganizationsSelect);
    const viewType: ISortMenuViewTypes = useSelector((state: any) => state.listPageBar.viewType);
    const orderbyTypes: ISortMenuOrderbyTypes[] = useSelector((state: any) => state.listPageBar.orderbyTypes);
    const changeViewEnabled: boolean = useSelector((state: any) => state.listPageBar.sortingEnabledOptions.changeViewEnabled);
    const filtersViewEnabled: boolean = useSelector((state: any) => state.listPageBar.sortingEnabledOptions.filtersViewEnabled);
    const orderByEnabled: boolean = useSelector((state: any) => state.listPageBar.sortingEnabledOptions.orderByEnabled);
    const actionMenuEnabled: boolean = useSelector((state: any) => state.listPageBar.sortingEnabledOptions.actionMenuEnabled);
    const actionMenuOptions: IDotMenu[] = useSelector((state: any) => state.listPageBar.actionMenuOptions);
    const launchpadSortingEnabled: boolean = useSelector((state: any) => state.listPageBar.sortingEnabledOptions.launchpadSortingEnabled);

    const dispatch = useDispatch();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleChangeView = () => {
        const type = viewType === 'list' ? 'tail' : 'list';
        dispatch(changeViewType(type));
    };

    const handleFiltersView = () => {
        const toggle = !showSortingFiltersMenu;
        dispatch(sortingFiltersEnabled(toggle));
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const Icon = viewType === 'list' ? ViewModule : ViewList;

    return (
        <>
            {showBullPhishOrganizationsSelect && <BullPhishOrganizationsSelect />}

            {(sortingEnabled || showOrganizationsSelect || showJitOrganizationsSelect) &&
                <div className='sortMenu'>
                    {showJitOrganizationsSelect ? <JitOrganizationsSelect /> : <OrganizationsSelect />}

                    {changeViewEnabled &&
                        <PasslyButton onClick={handleChangeView}>
                            <Icon />
                        </PasslyButton>
                    }

                    {filtersViewEnabled &&
                        <PasslyButton id='filterListButton' onClick={handleFiltersView}>
                            <FilterList />
                        </PasslyButton>
                    }
                    {orderByEnabled && orderbyTypes.length > 0 &&
                        <>
                            <PasslyButton id='moreVertButton' onClick={handleClick}>
                                <MoreVert />
                            </PasslyButton>
                            <Menu
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                {orderbyTypes.length && orderbyTypes.map((orderbyType, index) => (
                                    <MenuItem key={index} onClick={handleClose} value={orderbyType.value}>{orderbyType.name}</MenuItem>
                                ))}

                            </Menu>
                        </>
                    }
                </div>
            }
            {launchpadSortingEnabled &&
                <Box mr={1} flexDirection='row' display='flex'>
                    <LaunchpadSortingComponent />
                </Box>
            }
        </>
    );
};
